import { getIcons } from "_helpers";

const CustomTooltip = ({ bg, data, title, button }) => {

  return (
    <div className={"tooltip-container"}>
      <div className={"tooltip-title-container " + bg}>
        <span className={"tooltip-title "}> {title} </span>
      </div>
      <div className={"tooltip-content"}>
        {data && data.map((e, index) => (
          <div key={index}>
            {e.value !== null && e.value !== 'busAlertOutlinedGrey' &&
            <div className={"tooltip-element"}>
              {e.type === 'separator' ? (
                <hr className="separator" />
              ) : (
                <>
                  {e.icon && 
                  <span className={"font-light text-left"} style={{ marginRight: 20 }}>
                    <img src={getIcons(e.icon)} alt={e.icon} />
                  </span>}
                  {e.title && <span className={"font-light text-left text-global-mediumgrey"} style={{ marginRight: 20 }}>
                    {e.title}:
                  </span>}
                  <div>
                    <pre
                      style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}
                      dangerouslySetInnerHTML={{ __html: e.value }}
                    />
                  </div>
                </>
              )}
            </div>}
          </div>
        ))}
        {/* Ajout du bouton seulement si les informations sont fournies */}
        {button && button.label && (
          <div className="flex mt-4">
            <button
              className={`btn-custom btn-custom-primary m-auto ${bg}`}
              onClick={button.onClick}
            >
              {button.icon && (
                <img src={getIcons(button.icon)} alt={button.label} className="mr-2" />
              )}
              {button.label}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
export default CustomTooltip;